import { render, staticRenderFns } from "./ModalAssignApproval.vue?vue&type=template&id=172831da&"
import script from "./ModalAssignApproval.vue?vue&type=script&lang=js&"
export * from "./ModalAssignApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172831da')) {
      api.createRecord('172831da', component.options)
    } else {
      api.reload('172831da', component.options)
    }
    module.hot.accept("./ModalAssignApproval.vue?vue&type=template&id=172831da&", function () {
      api.rerender('172831da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalAssignApproval.vue"
export default component.exports